import React from 'react';

import { colors } from 'utils/styles/theme';

import { BackIconWrapperVariants } from './BackIcon.animations';

import * as S from './BackIcon.styles';

export interface BackIconProps {
  isOpen?: boolean;
  iconColor?: string;
  backgroundColor?: string;
  delay?: number;
  onClick?: () => void;
}

const defaultProps: Partial<BackIconProps> = {
  isOpen: true,
  delay: 0,
  iconColor: colors.lighterMineShaft,
  backgroundColor: colors.concrete,
};

const BackIcon: React.FunctionComponent<BackIconProps> = ({
  isOpen,
  delay = 0,
  backgroundColor,
  ...rest
}) => {
  return (
    <S.Wrapper
      animate={isOpen ? 'open' : 'close'}
      exit="close"
      backgroundColor={backgroundColor}
      variants={BackIconWrapperVariants}
      custom={{ delay: delay }}
      {...rest}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.94531"
          y="0.333984"
          width="1.99866"
          height="8.98247"
          transform="rotate(45 6.94531 0.333984)"
          fill={colors.lighterMineShaft}
        />
        <rect
          x="8.35938"
          y="11.6396"
          width="1.99866"
          height="9.01354"
          transform="rotate(135 8.35938 11.6396)"
          fill={colors.lighterMineShaft}
        />
      </svg>
    </S.Wrapper>
  );
};

BackIcon.defaultProps = defaultProps;

export default BackIcon;
